module.exports = __webpack_public_path__ + "static/media/question-note.ac690d87.svg";